import React from "react"

const LaunchReportLoading = () => {
  return (
    <div className="p-24 text-center text-lg">
      <i className="fa-solid fa-spin fa-spinner-third mr-3" />
      <span>Loading report</span>
    </div>
  )
}

export default LaunchReportLoading
